import { FormikErrors } from "formik";
import { AttributeFormState } from "@idw-types/state/attribute-form-state";
import { getAttributePlaceHolderValue } from "@utils/attribute-data-util";
import { AXNUITextInput } from "@iddataweb/idw-common-ui/containers";

type PlaceholderInputProps = {
    attribute: AttributeFormState;
	fieldName: string;
	setFieldValue: (field: string, value: any, shouldValidate?: boolean) => Promise<void> | Promise<FormikErrors<any>>;
	setFieldTouched: (field: string, isTouched?: boolean, shouldValidate?: boolean) => void;
	onSetSubmitValue: (payload: any) => void;
	isSubmitting: boolean;
};

export const PlaceholderInput = (props: PlaceholderInputProps) => {
	const { attribute } = props;

	return (
		<AXNUITextInput
			controlId={`placeholder-input-${attribute.type}`}
			automationId={`placeholder-input-${attribute.type}`}
			onChange={() => {}}
			onBlur={() => {}}
			title={undefined}
			required={!attribute.optional}
			disabled={true}
			value={getAttributePlaceHolderValue(attribute)}
		/>
	);
};